// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lPpg","col":"styles_col__3efAT"};